import { createRenderApi } from './render-api';
import { getInitData } from './tma';

export { RenderApiError } from './render-api';

export const renderApi = createRenderApi({
  baseUrl: import.meta.env.VITE_API_URL ?? '/api',
  getInitData,
});
